import { STATUS_LABELS } from "../data/js/listing-statuses";

/**
 * `labels` lets a caller show the same status from a different point of view — see
 * WATCHER_STATUS_LABELS, which the wishlist uses because "Not Active" means something
 * different to someone who cannot act on it.
 */
const AccountStatus = ({
  status,
  labels = STATUS_LABELS,
}: {
  status: number;
  labels?: string[];
}) => {
  /**
   * No `same-color-2` here, deliberately.
   *
   * It used to carry one, and the theme sets that surface as
   * `.theme.light .same-color-2` -- three classes, against the two of
   * `.account-status.num-1`. The theme won, so on the light theme every status
   * lost its colour and rendered as a flat #bbb slab. The statuses that have a
   * colour set their own; the ones that do not get a neutral from
   * `.account-status` itself, which is theme-aware and in no fight with
   * anything.
   */
  return (
    <div className={`account-status num-${status}`}>
      {labels[status]}
    </div>
  );
};

export default AccountStatus;
